import React from "react";

function DenRetention() {
  return (
    <div className="container">
      <h2>Den</h2>
      <h4>Den Boom Band</h4>

      <div>
        <h3>Den Login</h3>
        <img src="/images/image nitish/Matrix/DenLogin.png" alt="Den Login" />
      </div>

      <div>
        <h3>Den Report</h3>
        <img src="/images/image nitish/Matrix/DenReport.png" alt="Den Report" />
        <img src="/images/Matrix/DenReport1.png" alt="Den Report 1" />
      </div>

      <div>
        <h3>Den Field Screen</h3>
        <img src="/images/image nitish/Matrix/DenField.png" alt="Den Field" />
        <img src="/images/image nitish/Matrix/DenHome.png" alt="Den Home" />
      </div>

      <div>
        <h3>Den Calling Screen</h3>
        <img src="/images/image nitish/Matrix/DenDataScreen.png" alt="Den Data Screen" />
      </div>
    </div>
  );
}

export default DenRetention;